import { SVButton, SVLoader } from '@/components/core';
import DefaultLayout from '@/components/layouts/DefaultLayout';
import StaffDetailsActions from '@/components/staff/StaffDetailsActions';
import StaffDetailsBasicInfo from '@/components/staff/StaffDetailsBasicInfo';
import StaffDetailsView from '@/components/staff/StaffDetailsView';
import { ROUTES } from '@/constants/routes';
import { useGetStaffDetails } from '@/hooks/requests/useStaff';
import { createFullName } from '@/utils/string';
import { Card, Grid, Stack, Typography } from '@mui/material';
import { useNavigate, useParams } from 'react-router-dom';

export default function StaffDetails() {
  const navigate = useNavigate();
  const { uuid = '' } = useParams();
  const { staffDetails, isStaffDetailsPending } = useGetStaffDetails(uuid);
  const staffName = createFullName(
    staffDetails?.firstName,
    staffDetails?.lastName,
  );

  if (isStaffDetailsPending) {
    return (
      <DefaultLayout header="Staff Details">
        <SVLoader />
      </DefaultLayout>
    );
  }

  if (!staffDetails) {
    return (
      <DefaultLayout header="Staff Details">
        <Card>
          <Typography>
            Something went wrong retreiving the staff member. Our team has been
            notified.
          </Typography>
        </Card>
      </DefaultLayout>
    );
  }

  return (
    <DefaultLayout
      header="Staff Member Details"
      breadcrumb={[
        { label: 'Staff', href: ROUTES.STAFF },
        { label: staffName, isActive: true },
      ]}
      buttons={[
        <SVButton
          key="edit"
          aria-label={`Edit ${staffDetails.firstName}`}
          onClick={() =>
            navigate(`${ROUTES.STAFF_EDIT_PARAMS}/${staffDetails.uuid}`)
          }>
          Edit
        </SVButton>,
      ]}>
      <Stack spacing={2}>
        <StaffDetailsBasicInfo staffDetails={staffDetails} />
        <Grid container spacing={2}>
          <Grid size={{ xs: 12, md: 6 }}>
            <StaffDetailsView staffDetails={staffDetails} />
          </Grid>
          <Grid size={{ xs: 12, md: 6 }}>
            <StaffDetailsActions staffDetails={staffDetails} />
          </Grid>
        </Grid>
      </Stack>
    </DefaultLayout>
  );
}
